import {
  addExperienceController,
  deleteDataExperience,
  getBabySitterExperienceController,
} from "../../../Controllers/AppManagement/babySitter";
import { __permissionsObj } from "../../../constants";
import ExperienceManager from "../common/ExperienceManager";

export default function BabySitterExperience() {
  return (
    <ExperienceManager
      navTitle="Babysitter years of experience"
      getExperienceController={getBabySitterExperienceController}
      addExperienceController={addExperienceController}
      deleteExperienceController={deleteDataExperience}
      permissionType={__permissionsObj.BabySitter}
    />
  );
}